import { NgModule, APP_INITIALIZER } from '@angular/core';
import * as SERVICES from './index';
import { CfInterceptorModule } from '../interceptors/interceptors.module';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import'hammerjs';
/**
 * @param {?} configService
 * @return {?}
 */
export function ConfigLoader(configService: SERVICES.ConfigService) {
  // Note: this factory need to return a function (that return a promise)
  return () => configService.load('./fusion-config.json');
}
export class CfAutocompleteServiceModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpModule,
    HttpClientModule,
  ],
  declarations: [],
  entryComponents: [],
  providers: [
    SERVICES.AutocompleteService
  ],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAutocompleteServiceModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAutocompleteServiceModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAutocompleteServiceModule.ctorParameters;
}

export class CfAvatarServiceModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpModule,
    HttpClientModule,
  ],
  declarations: [],
  entryComponents: [],
  providers: [
    SERVICES.AvatarService
  ],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAvatarServiceModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAvatarServiceModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAvatarServiceModule.ctorParameters;
}

export class CfEventServiceModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  declarations: [],
  entryComponents: [],
  providers: [
    SERVICES.CfEventService
  ],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfEventServiceModule_tsickle_Closure_declarations() {
/** @type {?} */
CfEventServiceModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfEventServiceModule.ctorParameters;
}

export class CfServicesModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfInterceptorModule,
    HttpModule,
    HttpClientModule,
  ],
  declarations: [],
  entryComponents: [],
  providers: [
    SERVICES.DraggableService,
    SERVICES.HttpCacheService,
    SERVICES.TemplateService,
    SERVICES.ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [SERVICES.ConfigService],
      multi: true
    }
  ],
  exports: [],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfServicesModule_tsickle_Closure_declarations() {
/** @type {?} */
CfServicesModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfServicesModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
